module.exports = __webpack_public_path__ + "img/search-icon.d5fac849.svg";